import styled from 'styled-components';
import { breakpoint, spacing } from '../../../../styles/helpers';
import { theme } from '../../../../styles/theme';

export const ButtonGroup = styled.div`
  display: flex;
  margin-bottom: ${spacing.s};

  & > * {
    width: fit-content;

    ${breakpoint.mobile} {
      width: 100%;
    }
  }

  & > *:first-child {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  & > *:last-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  & > *:not(:first-child, :last-child) {
    border-radius: 0;
  }
`;

export const Label = styled.h6`
  color: ${theme.colors.textDisclaimer};
  ${theme.typography.h7};
  margin-bottom: ${spacing.xs};
`;
